import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class CustomersService {

    constructor(private http: HttpClient) { }

    // Get All Owners
    public getAllCustomers() {

        let paginationString = '';
        paginationString += '?size=' + 10000;
        paginationString += '&page=' + 0;

        return this.http.get(environment.apiUrl + 'api/ext-customer-user')
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get Owner by Owner ID
    public getAllCustomersByStore(id, pagination, sort) {
        let paginationString = '';
        paginationString += '?size=' + pagination.size;
        paginationString += '&page=' + pagination.page;

        const sortString = '&sort=' + sort;
        return this.http.get(environment.apiUrl + 'api/ext-customer-user-store/by-store/' + id + paginationString + sortString, { observe: 'response' })
            .pipe(map(this.handleDataWithHeaders))
            .pipe(catchError(this.handleError));
    }

    public getAllCustomersByStoreNoSort(id, pagination) {
        let paginationString = '';
        paginationString += '?size=' + pagination.size;
        paginationString += '&page=' + pagination.page;

        return this.http.get(environment.apiUrl + 'api/ext-customer-user-store/by-store/' + id + paginationString, { observe: 'response' })
            .pipe(map(this.handleDataWithHeaders))
            .pipe(catchError(this.handleError));
    }

    public getCustomerById(id) {
        return this.http.get(environment.apiUrl + 'api/ext-customer-user/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    public getCustomerByPurchase(id) {
        return this.http.get(environment.apiUrl + 'api/ext-customer-user/by-purchase/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // HANDLE DATA
    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }


    public handleDataWithHeaders(res: HttpResponse<any>) {

        const headers = res.headers;
        const body = res.body;
        const data = {
            'headers': headers,
            'body': body
        };
        return data;
    }


    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/customer.service.ts